
<f-dialog
    v-if       = "inspection"
    :title     = "$t('disposition.inspection.tooltip.assign')"
    v-model    = "value"
    :width     = "460"
    storeLabel = "Zuordnen"
    :show-save = "!!unit"
    @cancel    = "onCancel"
    @store     = "onAssign"
>
    <template v-slot:toolbar>
        <c-toolbar-button
            v-if     = "unit"
            color    = "white"
            size     = "24"
            icon     = "mdi-magnify"
            :tooltip = "$t('disposition.inspection.tooltip.search')"
            @click   = "unit = null"
            class    = "mr-1"
        />
    </template>
    <template v-slot:content>
        <c-site-select-single
            v-if       = "!unit"
            :customer  = "inspection.order.customer"
            :all-units = "true"
            @site      = "onSite"
        />
        <div v-if="unit">
            <v-row dense class="mt-1">
                <v-col>
                    <f-read-only-field
                        :label = "$t('disposition.inspection.hcid')"
                        class  = "pr-2"
                        :value = "unit.id"
                        filled
                        frame
                        dense
                    />
                </v-col>
                <v-col>
                    <f-read-only-field
                        :label = "$t('disposition.inspection.no')"
                        class  = "pr-2"
                        :value = "unit.fabricNo"
                        filled
                        frame
                        dense
                    />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col>
                    <f-read-only-field
                        :label = "$t('disposition.inspection.zip')"
                        class  = "pr-2"
                        :value = "zip"
                        filled
                        frame
                        dense
                    />
                </v-col>
                <v-col>
                    <f-read-only-field
                        :label = "$t('disposition.inspection.city')"
                        class  = "pr-2"
                        :value = "unit.city"
                        filled
                        frame
                        dense
                    />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col>
                    <f-read-only-field
                        :label = "$t('disposition.inspection.street')"
                        class  = "pr-2"
                        :value = "unit.street"
                        filled
                        frame
                        dense
                    />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col>
                    <f-read-only-field
                        :label = "$t('disposition.unit.ve')"
                        class  = "pr-2"
                        :value = "unit.ve"
                        filled
                        frame
                        dense
                    />
                </v-col>
                <v-col>
                    <f-read-only-field
                        :label = "$t('disposition.unit.ve2')"
                        class  = "pr-2"
                        :value = "unit.ve2"
                        filled
                        frame
                        dense
                    />
                </v-col>
            </v-row>
            <v-row dense class="mb-3">
                <v-col>
                    <f-read-only-field
                        :label = "$t('disposition.unit.ve3')"
                        class  = "pr-2"
                        :value = "unit.ve3"
                        filled
                        frame
                        dense
                    />
                </v-col>
            </v-row>
        </div>
    </template>
</f-dialog>
